import React from 'react';
import { useSelect } from '../api';

export function DisplayCate({ value }: { value: number }) {
  const { data, isLoading, isError } = useSelect({
    params: {
      pageIndex: 1,
      pageSize: 1000,
    },
  });
  if (isLoading || isError) return <div>...</div>;
  const item = data?.data.items.find((v) => v.id === value);
  return <div>{item?.name}</div>;
}
